import React, { createContext, useState, useContext, useEffect } from 'react';
import { GetApproversList, GetManager, GetSponsorDetails } from '../services/user-service';
import { useUserContext } from './user/context';
import { Approver } from 'models/IApprover';

const SponsorContext = createContext<any>(undefined);

export const Sponsor: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [sponsor, setSponsorDetails] = useState<any>();
  const userInfo = useUserContext();
  const [approvers, setApprovers] = useState<Approver[]>();
  const [manager, setManager] = useState<Approver>();
  const [fetched, setFetched] = useState(false);
  const [tacDetails, setTacDetails] = useState<{
    tacTemplateName: string;
    enabletac: boolean;
  }>({
    tacTemplateName: '',
    enabletac: false,
  });
  useEffect(() => {
    const sponsorId = userInfo?.passplayUser?.sponsorId;
    if (sponsorId) {
      GetSponsorDetails(sponsorId).then(sponsor => {
        setSponsorDetails(sponsor.data);
      });
    }
  }, [userInfo?.passplayUser]);

  const fetchApproversAndManager = async () => {
    if (fetched) return;
    const [approvers, manager] = await Promise.all([GetApproversList(), GetManager()]);
    setApprovers(approvers);
    setManager(manager);
    setFetched(true);
  };

  return (
    <SponsorContext.Provider
      value={{
        sponsor,
        setSponsorDetails,
        approvers,
        setApprovers,
        manager,
        setManager,
        fetchApproversAndManager,
        tacDetails,
        setTacDetails,
      }}
    >
      {children}
    </SponsorContext.Provider>
  );
};

export const useSponsorContext = () => {
  const context = useContext(SponsorContext);
  if (context === undefined) {
    throw new Error('useSponsorContext must be used within a SponsorProvider');
  }
  return context;
};
